import React from 'react';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { jwtDecode } from 'jwt-decode';

import translate from './translate';
import Auth from '../Auth';

interface IntlWrapperProps {
  locale?: string;
  messages?: any;
  children: React.ReactNode;
}

class IntlWrapper extends React.Component<IntlWrapperProps> {
  render() {
    const { children, locale, messages } = this.props;

    const SafeIntlProvider = IntlProvider as unknown as React.ComponentType<any>;

    return (
      <SafeIntlProvider locale={locale} messages={messages} defaultLocale="en">
        {children}
      </SafeIntlProvider>
    );
  }
}

function mapStateToProps() {
  const token = Auth.getToken();
  const oldLang = !localStorage.getItem('language')
    ? 'LT'
    : localStorage.getItem('language');
  const lang = !token
    ? oldLang
    : jwtDecode<{ language: string }>(token).language;

  localStorage.setItem('language', lang!);

  const locale: string = lang!.toLowerCase();
  const messages = translate(lang!);

  return { locale, messages };
}

export default connect(mapStateToProps)(IntlWrapper);
